"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _pipelineActions = require("../actions/pipelineActions");

var _DealPipeline = _interopRequireDefault(require("customer-data-objects/deal/DealPipeline"));

var _TicketPipeline = _interopRequireDefault(require("customer-data-objects/ticket/TicketPipeline"));

var _PipelinesRecord = _interopRequireDefault(require("../records/PipelinesRecord"));

var _Constants = require("../Constants");

var initialState = (0, _immutable.Map)({
  pipelines: new _PipelinesRecord.default(),
  isLoaded: false
});

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _pipelineActions.GetPipelinesActionTypes.SUCCESS:
      return action.payload.data.sort(function (a, b) {
        return a.displayOrder <= b.displayOrder;
      }).reduce(function (newState, pipeline) {
        if (pipeline.objectType === _Constants.DEAL_OBJECT_TYPE) {
          return newState.updateIn(['pipelines', 'dealPipelines'], function (pipelines) {
            return pipelines.set(pipeline.pipelineId, _DealPipeline.default.fromJS(pipeline));
          });
        }

        if (pipeline.objectType === _Constants.TICKET_OBJECT_TYPE) {
          return newState.updateIn(['pipelines', 'ticketPipelines'], function (pipelines) {
            return pipelines.set(pipeline.pipelineId, _TicketPipeline.default.fromJS(pipeline));
          });
        }

        return newState;
      }, state.set('isLoaded', true));

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;